import React from "react";
import { Text, View, Image } from "@react-pdf/renderer";
import { CommonStyles } from "../pdf-styles";
import PropertyImage from "../../assets/images/pdf-default.png";

export const Header = ({ logo, companyName, propertyName, address, children }) => {
  const companyLogo = typeof logo === "string" ? logo : logo?.original;
  const logoUrl = `https://s3.amazonaws.com/idp-rpm-v4/${companyLogo}`;

  return (
    <View fixed style={CommonStyles.header}>
      <View style={CommonStyles.logoContainer}>
        {logo ? <Image style={CommonStyles.logo} src={logoUrl} /> : <Text>{companyName}</Text>}
      </View>
      <View style={CommonStyles.letterheadContainer}>
        <View style={CommonStyles.propertyImageContainer}>
          <Image style={CommonStyles.propertyImage} src={PropertyImage} />
        </View>
        <View style={CommonStyles.letterhead}>
          <Text style={CommonStyles.propertyName}>{propertyName}</Text>
          <Text style={CommonStyles.address}>{address}</Text>
          {children}
        </View>
      </View>
    </View>
  )
}
